<section mat-dialog-title>
  <span>Select Wi-Fi</span>

  <button mat-dialog-close>
    <i class="icon-close"></i>
  </button>
</section>

<mat-dialog-content>
  @if (browserHelpers.isBluetoothSupported()) {
    <avs-wifi-picker [deviceId]="data!.deviceId" />
  } @else {
    <p>This feature is only available in Chromium-based browsers. Please use a compatible browser to update Wi-Fi connection</p>

    <div class="text-right mt-5">
      <a
        href="https://www.google.com/chrome/"
        mat-flat-button
        rel="noopener noreferrer"
        target="_blank"
      >
        <mat-icon fontIcon="open_in_new" />
        <ng-container>Visit Chrome Website</ng-container>
      </a>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions
  class="gap-3"
  align="end"
>
  <button
    mat-button
    mat-dialog-close
  >
    Cancel
  </button>

  @if (wifiPicker().isConnected()) {
    <button
      class="btn-green btn-medium"
      (click)="connect()"
      [disabled]="!wifiPicker().isValid()"
    >
      Connect
    </button>
  }
</mat-dialog-actions>
